import styled from 'styled-components';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

export const SAccordion = styled(({ theme, ...props }) => <Accordion {...props} />)`
  && {
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.palette.colors.gray200};
    margin: 0 !important;
    box-shadow: none;
    :before {
      display: none;
    }
  }
`;

export const SMuiAccordionDetails = styled(({ theme, ...props }) => <AccordionDetails {...props} />)`
  && {
    :hover {
      border-color: ${({ theme, variant }) =>
        variant === 'light' ? theme.palette.colors.gray300 : 'inherit'};
    }
  }
`;

export const SAccordionSummary = styled(({ theme, ...props }) => <AccordionSummary {...props} />)`
  && {
    background-color: ${({ theme, variant }) =>
      variant === 'light' ? 'inherit' : theme.palette.colors.gray100};
    border-radius: 6px 6px 0 0;
    font-weight: 600;

    .MuiAccordionSummary-content {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    :hover {
      border-color: ${({ theme, variant }) =>
        variant === 'light' ? theme.palette.colors.gray300 : 'inherit'};
    }
  }
`;

export const STitle = styled.div`
  display: flex;
`;

export const SSubTitle = styled.p`
  color: ${({ theme }) => theme.palette.colors.gray400};
  font-weight: 500;
  font-size: 14px;
`;
